// actionTypes.js

export const GET_SEBEL_USERS = 'GET_SEBEL_USERS';
export const GET_SEBEL_USERS_SUCCESS = 'GET_SEBEL_USERS_SUCCESS';
export const GET_SEBEL_USERS_FAIL = 'GET_SEBEL_USERS_FAIL';

export const ADD_SEBEL_USER = 'ADD_SEBEL_USER';
export const ADD_SEBEL_USER_SUCCESS = 'ADD_SEBEL_USER_SUCCESS';
export const ADD_SEBEL_USER_FAIL = 'ADD_SEBEL_USER_FAIL';

export const UPDATE_SEBEL_USER = 'UPDATE_SEBEL_USER';
export const UPDATE_SEBEL_USER_SUCCESS = 'UPDATE_SEBEL_USER_SUCCESS';
export const UPDATE_SEBEL_USER_FAIL = 'UPDATE_SEBEL_USER_FAIL';

export const DELETE_SEBEL_USER = 'DELETE_SEBEL_USER';
export const DELETE_SEBEL_USER_SUCCESS = 'DELETE_SEBEL_USER_SUCCESS';
export const DELETE_SEBEL_USER_FAIL = 'DELETE_SEBEL_USER_FAIL';

export const SET_SEBEL_USER_FIELD_ERRORS = 'SET_SEBEL_USER_FIELD_ERRORS';
